export default "__VITE_ASSET__dEK91Ljw__"